import Vue from "vue";
import VueI18n from "vue-i18n";
import validationPl from "@/i18n/lang/validation-pl";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "pl",
  fallbackLocale: "en",
  messages: {
    pl: { ...validationPl }
  }
});

// export default ({ app }) => {
//   app.i18n = i18n;
// };

export { i18n };
